import { createStore } from "@tredespace/ui/lib";

export type HistoryState = Readonly<{
  canUndo: boolean;
  canRedo: boolean;
}>;

export const historyState = createStore<HistoryState>({ canUndo: false, canRedo: false });
